import type { LucideIcon } from "lucide-react";
import {
  Terminal,
  Settings,
  Sparkles,
  AppWindow,
  Package,
  StickyNote,
  Folder,
  Globe,
  Code2,
  Bot,
  Image,
  Music,
  Calculator,
  Mail,
  Calendar,
  Camera,
  Search,
  Info,
  Hexagon,
  Activity,
  Clock,
  TrendingUp,
  CloudSun,
} from "lucide-react";

/** Map module ids / dock labels → Lucide icons (ArcLog visual language). */
const BY_ID: Record<string, LucideIcon> = {
  "app.terminal": Terminal,
  "app.settings": Settings,
  "app.hello-demo": Sparkles,
  "app.hermes": Sparkles,
  "app.packages": Package,
  "app.notes": StickyNote,
  "app.notepad": StickyNote,
  "app.files": Folder,
  "app.media": Image,
  "app.users": Bot,
  "app.release-notes": Info,
  "app.sdk-docs": Info,
  "app.code": Code2,
  "app.activity-monitor": Activity,
  "app.calculator": Calculator,
  "widget.clock": Clock,
  "widget.compound": TrendingUp,
  "widget.weather": CloudSun,
  "theme.macos-glass": Hexagon,
  "wallpaper.aurora": Image,
};

const BY_LABEL: Record<string, LucideIcon> = {
  terminal: Terminal,
  settings: Settings,
  hello: Sparkles,
  package: Package,
  packages: Package,
  notes: StickyNote,
  files: Folder,
  browser: Globe,
  code: Code2,
  agent: Bot,
  hermes: Bot,
  media: Image,
  music: Music,
  calc: Calculator,
  calculator: Calculator,
  mail: Mail,
  calendar: Calendar,
  camera: Camera,
  search: Search,
  about: Info,
  activity: Activity,
  monitor: Activity,
  clock: Clock,
  time: Clock,
  weather: CloudSun,
  forecast: CloudSun,
  compound: TrendingUp,
  finance: TrendingUp,
  trending: TrendingUp,
  stock: TrendingUp,
  stocks: TrendingUp,
  trading: TrendingUp,
};

export function resolveAppIcon(
  appId?: string,
  label?: string,
  explicit?: string
): LucideIcon {
  if (appId && BY_ID[appId]) return BY_ID[appId];
  const key = (explicit || label || "").toLowerCase().trim();
  if (key && BY_LABEL[key]) return BY_LABEL[key];
  // heuristicchic from id
  const id = (appId || "").toLowerCase();
  if (id.includes("term")) return Terminal;
  if (id.includes("set")) return Settings;
  if (id.includes("note")) return StickyNote;
  if (id.includes("pack")) return Package;
  if (id.includes("code") || id.includes("dev")) return Code2;
  return AppWindow;
}

export type { LucideIcon };
